import { render, staticRenderFns } from "./EmergencyServices.vue?vue&type=template&id=461bb8be&scoped=true"
import script from "./EmergencyServices.vue?vue&type=script&lang=js"
export * from "./EmergencyServices.vue?vue&type=script&lang=js"
import style0 from "./EmergencyServices.vue?vue&type=style&index=0&id=461bb8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461bb8be",
  null
  
)

export default component.exports